import Choices from 'choices.js';
const {noChoicesText, noResultsText, loadingText, placeholderValue, placeholderValueDate} = kreenoot_child.choices_js;

if(document.getElementById('js-choice')) {
    const choices = new Choices('#js-choice', {
        searchEnabled: true,
        searchChoices: true,
        loadingText,
        noResultsText,
        noChoicesText,
        itemSelectText: '',
        removeItemButton: true,
        placeholder: true,
        placeholderValue,
    });
}

if(document.getElementById('js-choice-date')) {
    const choices_date = new Choices('#js-choice-date', {
        searchEnabled: true,
        searchChoices: true,
        loadingText,
        noResultsText,
        noChoicesText,
        itemSelectText: '',
        removeItemButton: true,
        placeholder: true,
        placeholderValue: placeholderValueDate,
        searchFloor: 1,
    });
}


// Filters for publications
let resetButton = document.querySelector('.reset_publications')

resetButton?.addEventListener('click', function(){
    document.querySelectorAll('.chbx-cat').forEach(c => {c.checked = false})
    document.querySelector('#search_name').value = ''
    
    choices.removeActiveItems()
    choices_date.removeActiveItems()
})
